import Head from 'next/head';
import type { GetStaticPaths, GetStaticProps } from 'next';

import Layout from '@/components/layout';
import SiteContextProvider from '@/contexts/siteContext';
import { DEFAULT_REVALIDATE_TIME } from '@/constants';
import { getSingleSiteData } from '@/lib/fetchers/sites';
import type { SitePageProps, SiteParams } from '@/types';

export const getStaticPaths: GetStaticPaths<SiteParams> = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<
  SitePageProps,
  SiteParams
> = async ({ params }) => {
  const site = await getSingleSiteData(params?.site);

  return {
    props: { site },
    revalidate: Number.parseInt(
      process.env.ISR_REVALIDATE_TIME || DEFAULT_REVALIDATE_TIME,
    ),
  };
};

const Faq = ({ site }: SitePageProps) => {
  return (
    <SiteContextProvider site={site}>
      <Head>
        <title key="title">Facts and FAQs</title>
        <meta
          name="description"
          content="Frequently asked questions and basic information"
        />
      </Head>
      <Layout>
        <div
          className="server-content"
          dangerouslySetInnerHTML={{
            __html: site?.html_faqs ?? 'Coming soon',
          }}
        />
      </Layout>
    </SiteContextProvider>
  );
};

export default Faq;
